import axios from "axios";

// Empty = same origin (muviarts.online/api via the Pages Function proxy).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const WEBHOOK_URL = `${BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "")}/api/webhooks/whatsapp`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;
